module.exports = __webpack_public_path__ + "img/dzdp01.22deaea1.png";